<template>
    <p>
        {{information}}
    </p>
</template>

<script>
export default {
    props: ['information'],
};
</script>

<style>

</style>
